export interface SseEvent {
  event: string
  data: string
}

/**
 * Lee un stream `text/event-stream` con `fetch` (no `EventSource`) para poder adjuntar
 * el header `Authorization`, que `EventSource` no soporta.
 */
export async function* streamEvents(
  url: string,
  init: RequestInit,
): AsyncGenerator<SseEvent, void, unknown> {
  const response = await fetch(url, init)
  if (!response.ok || !response.body) {
    throw new Error(`No fue posible abrir el stream (HTTP ${response.status}).`)
  }

  const reader = response.body.getReader()
  const decoder = new TextDecoder()
  let buffer = ''

  try {
    while (true) {
      const { done, value } = await reader.read()
      if (done) break
      buffer += decoder.decode(value, { stream: true })

      let boundary = buffer.indexOf('\n\n')
      while (boundary !== -1) {
        const rawEvent = buffer.slice(0, boundary)
        buffer = buffer.slice(boundary + 2)

        let eventName = 'message'
        const dataLines: string[] = []
        for (const line of rawEvent.split('\n')) {
          if (line.startsWith('event:')) eventName = line.slice(6).trim()
          else if (line.startsWith('data:')) dataLines.push(line.slice(5).trim())
        }
        if (dataLines.length > 0) {
          yield { event: eventName, data: dataLines.join('\n') }
        }
        boundary = buffer.indexOf('\n\n')
      }
    }
  } finally {
    reader.releaseLock()
  }
}
